module.exports = __webpack_public_path__ + "media/images/wines/Montepulciano-dAbruzzo-6acdc6ffa52e9ad9e6dda0e8fe01eeb0.jpg";